<template>
  <div class="habits-day__wrapper">
    <div class="habits-day__header" v-if="habitForThisDay.length !== 0 && selectedDayIsToday">
      <HabitModal
        :addActivityHabits="addActivityHabits"
        :isActiveModal="isActiveModal"
        :habitForThisDay="habitForThisDay"
        :makeModalUnActive="makeModalUnActive"
        :isButton="!!user.uid && isOnline"
      />
    </div>
    <div class="empty-state-wrapper" style="margin-top: 90px;"
      v-if="!habitForThisDay.length && isDateToday">
      <div class="empty-state-wrapper__box">
        <div class="empty-state-wrapper__box--text">
          {{ $t('habit.noHabits') }} </div>
      </div>
    </div>
    <div class="empty-state-wrapper__box--text"
      style="text-align: center;"
      v-if="!isDateToday && habitForThisDay.length === 0">
        {{ $t(`${translationPath}.noHabit`) }}</div>
    <HabitModal
        :addActivityHabits="addActivityHabits"
        :isActiveModal="isActiveModal"
        :habitForThisDay="habitForThisDay"
        :makeModalUnActive="makeModalUnActive"
        :isButton="false"
      />
      <div style="display: flex; justify-content: space-between;">
        <div @click="createNewGroupEvent()" style="margin-bottom: 10px;">Dodaj grupę</div>
      </div>
    <div v-if="habitForThisDay">
      <div
        :key="index"
        v-for="(group, index) in groupsWithHabits"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 20px 15px;
            margin: 10px 0 10px 0;
            cursor: pointer;
            font-weight: 800;
            font-size: 20px;
            background: #1b263bd9;
            border-radius: 10px 20px 20px 20px;
          "
          @click="groupsWithHabits[index].id !== 'noGroup'
            ? groupsWithHabits[index].show = !groupsWithHabits[index].show : ''">
          <div>
            {{ group.name }}
             <span style="
              font-weight: 800;
              color: #a2a2a2;
             ">({{ groupsWithHabits[index].habits.length }})</span>
             <font-awesome-icon
              v-if="groupsWithHabits[index].id !== 'noGroup'"
              @click="changePositionOfGroup(groupsWithHabits[index])"
              style="margin-left: 10px;" icon="angle-up" />
          </div>
          <font-awesome-icon
            icon="trash"
            v-if="groupsWithHabits[index].id !== 'noGroup'" @click="removeGroup(group)"/>
        </div>
        <draggable
          handle=".handle"
          class="list-group"
          tag="ul"
          v-model="groupsWithHabits[index].habits"
          v-bind="dragOptions"
          @start="drag = true"
          @end="onEnd"
        >
          <div
            style="position: relative;"
            v-for="habitId in groupsWithHabits[index].habits" :key="habitId"
          >
            <HabitItem
              v-if="habitDate(habitId)"
              :daysArr="daysArr"
              :habit="habitDate(habitId)"
              :addActivityLog="addActivityLog"
              :removeActivityLog="removeActivityLog"
              :activityForSelectedDay="activityForSelectedDay"
              :activityLogs="activityLogs"
              :selectedDay="selectedDay"
              :editActivityHabitsEvent="editActivityHabitsEvent"
              :isActiveParent="isActiveParent"
            />
            <div class="handle"
              v-if="habitDate(habitId)"
              style="
                position: absolute; top: 35%; right: 5px;
                color: black; font-weight: 800; cursor: pointer;
                border-radius: 5px; background: white; padding: 1px 2px;
              ">
              <font-awesome-icon size="lg"
                icon="grip-vertical"/>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <div class="habits-day__add-habit" @click="makeModalUnActive(true)">
      <div class="habits-day__add-habit--button">
        <div class="habits-day__add-habit--button--icon">
          <font-awesome-icon icon="plus" />
        </div>
        <div class="habits-day__add-habit--button--text">
          {{ $t('habit.addHabit') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable radix */

import { mapActions, mapState } from 'vuex';
import draggable from 'vuedraggable';
import HabitItem from './HabitItem.vue';
import HabitModal from './HabitModal.vue';
import habitHelpers from '../../../helpers/habitHelper';

export default {
  components: {
    HabitItem,
    HabitModal,
    draggable,
  },
  data() {
    return {
      isActiveParent: false,
      isActiveModal: false,
      daysCountStats: 30,
      allDays: true,
      translationPath: 'habits',
      daysArr: this.$getDaysFromNow(30),
      disabledDrag: false,
    };
  },
  props: {
    activityLogs: Array,
    selectedDay: String,
    addActivityLog: Function,
    removeActivityLog: Function,
    editActivityHabits: Function,
    addActivityHabits: Function,
    updateActivityLog: Function,
    addRemoveActivityLog: Function,
    habitsWithLogs: Array,
    user: Object,
    isOnline: Boolean,
  },
  computed: {
    ...mapState({
      groupsOfHabits: (state) => state.habitsDashboard.groupsOfHabits,
    }),
    habitForThisDay() {
      const habitForDay = habitHelpers.activeHabits(this.selectedDay, this.habitsWithLogs) || [];
      return habitForDay;
    },
    activityForSelectedDay() {
      return this.activityLogs.filter((log) => this.isToday(log));
    },
    isDateToday() {
      return this.$moment(this.selectedDay).format('DD-MM-YYYY') === this.$moment().format('DD-MM-YYYY');
    },
    selectedDayIsToday() {
      return this.$moment(this.selectedDay).isSame(this.$moment(), 'day');
    },
    groupsWithHabits() {
      const habitsWithoutGroup = {
        id: 'noGroup',
        name: 'Bez grupy',
        habits: [],
      };
      // grupa noGroups powinna być w  storage też dlatego, ze psuje się drag and drop
      this.habitForThisDay.forEach((habit) => {
        const findedGroup = this.groupsOfHabits.find(
          (group) => group.habits.includes(habit.localId),
        );
        if (!findedGroup) {
          habitsWithoutGroup.habits.push(habit.localId);
        }
      });
      console.log('[...this.groupsOfHabits, habitsWithoutGroup]', [...this.groupsOfHabits, habitsWithoutGroup]);
      return [...this.groupsOfHabits, habitsWithoutGroup];
    },

    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: this.disabledDrag,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    ...mapActions({
      setGroupsOfHabits: 'habitsDashboard/setGroupsOfHabits',
      createNewGroup: 'habitsDashboard/createNewGroup',
    }),
    isToday(log) {
      return this.$moment(log.date).startOf('day').isSame(this.selectedDay, 'day');
    },
    editActivityHabitsEvent(habit) {
      const updateItem = {
        ...habit,
        isActive: false,
        endDate: this.$moment().toISOString(),
      };
      this.editActivityHabits(updateItem);
    },
    makeModalUnActive(status) {
      this.isActiveModal = status;
    },
    onEnd() {
      this.drag = false;
      this.setGroupsOfHabits(this.groupsWithHabits.filter((group) => group.id !== 'noGroup'));
      localStorage.setItem('groupsOfHabits', JSON.stringify(this.groupsWithHabits.filter((group) => group.id !== 'noGroup')));
    },
    habitDate(habitId) {
      const returnedHabit = this.habitForThisDay.find((habit) => habit.localId === habitId);
      return returnedHabit;
    },
    async createNewGroupEvent() {
      const nameOfGroup = await prompt('Enter name of group');
      this.createNewGroup({ name: nameOfGroup });
      localStorage.setItem('groupsOfHabits', JSON.stringify(this.groupsWithHabits.filter((group) => group.id !== 'noGroup')));
    },
    removeGroup(group) {
      const index = this.groupsWithHabits.findIndex((item) => item.id === group.id);
      this.groupsWithHabits.splice(index, 1);
      this.setGroupsOfHabits(this.groupsWithHabits.filter((groupA) => groupA.id !== 'noGroup'));
      localStorage.setItem('groupsOfHabits', JSON.stringify(this.groupsWithHabits.filter((group2) => group2.id !== 'noGroup')));
    },
    changePositionOfGroup(group) {
      const index = this.groupsWithHabits.findIndex((item) => item.id === group.id);
      this.groupsWithHabits.splice(index, 1);
      this.groupsWithHabits.unshift(group);
      this.setGroupsOfHabits(this.groupsWithHabits.filter((groupA) => groupA.id !== 'noGroup'));
      localStorage.setItem('groupsOfHabits', JSON.stringify(this.groupsWithHabits.filter((group2) => group2.id !== 'noGroup')));
    },
  },
  mounted() {
    this.setGroupsOfHabits(JSON.parse(localStorage.getItem('groupsOfHabits')) || []);
  },
};
</script>

<style lang="scss" scoped>
  .habits-day {
    &__wrapper {
      padding: 0 10px;
      margin-top: 40px;
    }
    &__header {
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 20px;
        font-weight: 700;
      }
    }
    &__add-habit {
      width: 100%;
      margin: 30px 0;
      &--button {
        color: white;
        border: 1px dotted white;
        width: 90%;
        height: 80px;
        margin: 0 auto;
        border-radius: 30px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &--icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &--text {
          font-size: 16px;
          font-weight: 700;
          color: white;
        }
      }
      &--board {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .empty-state-wrapper {
    position: relative;
    margin-top: 25px;
    text-align: center;
    &__box {
      width: 100%;
      margin-top: 45px;
      &--text {
        width: 100%;
        font-weight: 500;
        font-weight: 600;
        font-size: 25px;
        margin-top: 25px;
      }
      &--button {
        margin: 0 auto;
        padding: 15px 25px;
        background: $background-brand-color;
        color: $font-light-color;
        margin-top: 25px;
        border-radius: 25px;
        font-weight: 700;
        width: 90vw;
      }
    }
  }

</style>
